<div class="flex flex-col w-full space-y-8">
	<div class="flex flex-row justify-between gap-8">
		<ui-section title="Terms">
			<div section-content>
				<div class="flex flex-col space-y-6">
					<div class="flex">
						<app-checkbox
							type="clear"
							[ngModel]="_mortgage.interestOnlyPayments"
							(ngModelChange)="setInterestOnlyPayments($event)"
							>Interest only payments</app-checkbox
						>
					</div>

					<div class="flex flex-row gap-x-6">
						<div class="flex-1">
							<app-input
								[forceErrorState]="forceErrorState && !_mortgage.term"
								*ngIf="registeredEditable"
								label="{{
									_mortgage?.transactionType === transactionTypes.VTB
										? 'Term (years)'
										: 'Term'
								}}"
								[ngModel]="_mortgage.term"
								(debounce)="setTerm($event)"
							></app-input>
							<div *ngIf="!registeredEditable" class="flex flex-col">
								<span>Term</span>
								<span *ngIf="_mortgage.term">{{ _mortgage.term }}</span>
								<span *ngIf="!_mortgage.term">N/A</span>
							</div>
						</div>
						<div class="flex-1">
							<app-input
								*ngIf="registeredEditable"
								label="{{
									_mortgage?.transactionType === transactionTypes.VTB
										? 'Amortization (years)'
										: 'Amortization'
								}}"
								[forceErrorState]="forceErrorState && !_mortgage?.amortization"
								[ngModel]="_mortgage.amortization"
								(debounce)="setAmortization($event)"
							></app-input>
							<div *ngIf="!registeredEditable" class="flex flex-col">
								<span>Amortization</span>
								<span *ngIf="_mortgage.amortization">{{
									_mortgage.amortization
								}}</span>
								<span *ngIf="!_mortgage.amortization">N/A</span>
							</div>
						</div>
					</div>

					<app-radio-group
						label="Insurance Amount"
						type="compact"
						[items]="insuranceAmountOptions"
						[ngModel]="_mortgage.insuranceAmount"
						(ngModelChange)="setInsuranceAmount($event)"
					></app-radio-group>
				</div>
			</div>
		</ui-section>
		<ui-section title="Loan Details">
			<div section-content>
				<div class="mt-7">
					<h4 class="mb-5"></h4>
					<app-mortgage-net-amount
						[forceErrorState]="forceErrorState && !_mortgage.amount"
						[editable]="registeredEditable"
						[mortgage]="_mortgage"
					></app-mortgage-net-amount>
				</div>
			</div>
		</ui-section>
	</div>
	<div class="w-full flex flex-col">
		<ui-section title="Payments">
			<div section-content class="flex flex-col gap-4">
				<form
					#form="ngForm"
					(ngSubmit)="viewAmortizationScheduleDocument(form)"
				>
					<table
						class="app-table table-auto border rounded-xl border-grey-veryLight p-2 mt-5 w-full"
					>
						<thead>
							<tr>
								<th>Item</th>
								<th class="w-1/2">As registered</th>
								<th class="w-1/2">Actual</th>
							</tr>
						</thead>
						<tbody class="[&>tr>td:first-child]:whitespace-nowrap">
							<tr>
								<td>Payment Date and Period</td>
								<td>
									<app-input
										name="paymentDueAsReg"
										[ngModel]="_mortgage?.paymentDueAsReg"
										[placeholder]="_mortgage?.paymentDue ?? ''"
										(debounce)="setPaymentDueAsReg($event)"
									></app-input>
								</td>
								<td>
									<app-input
										*ngIf="registeredEditable"
										name="paymentDue"
										[ngModel]="_mortgage?.paymentDue"
										(debounce)="setPaymentDue($event)"
									></app-input>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.paymentDue
									}}</span>
								</td>
							</tr>
							<tr>
								<td>Interest Adjustment Date</td>
								<td>
									<app-date-picker
										name="interestAdjustmentDateAsReg"
										[ngModel]="_mortgage?.interestAdjustmentDateAsReg"
										[placeholder]="_mortgage?.interestAdjustmentDate"
										(ngModelChange)="setInterestAdjustmentDateAsReg($event)"
									></app-date-picker>
								</td>
								<td>
									<app-date-picker
										name="interestAdjustmentDate"
										*ngIf="registeredEditable"
										[ngModel]="_mortgage?.interestAdjustmentDate"
										[forceErrorState]="
											forceErrorState && !_mortgage?.firstPaymentDate
										"
										[required]="true"
										(ngModelChange)="setInterestAdjustmentDate($event)"
									></app-date-picker>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.interestAdjustmentDate
									}}</span>
								</td>
							</tr>
							<tr>
								<td>First Payment Date</td>
								<td>
									<app-date-picker
										name="firstPaymentDateAsReg"
										[ngModel]="_mortgage?.firstPaymentDateAsReg"
										[placeholder]="_mortgage?.firstPaymentDate"
										(ngModelChange)="setFirstPaymentDateAsReg($event)"
									></app-date-picker>
								</td>
								<td>
									<app-date-picker
										*ngIf="registeredEditable"
										name="firstPaymentDate"
										[forceErrorState]="
											forceErrorState && !_mortgage?.firstPaymentDate
										"
										[required]="true"
										[ngModel]="_mortgage?.firstPaymentDate"
										(ngModelChange)="setFirstPaymentDate($event)"
									></app-date-picker>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.firstPaymentDate
									}}</span>
								</td>
							</tr>
							<tr>
								<td>Last Payment Date</td>
								<td>
									<app-date-picker
										name="lastPaymentDateAsReg"
										[ngModel]="_mortgage?.lastPaymentDateAsReg"
										[placeholder]="_mortgage?.lastPaymentDate"
										(ngModelChange)="setLastPaymentDateAsReg($event)"
									></app-date-picker>
								</td>

								<td>
									<app-date-picker
										*ngIf="registeredEditable"
										name="lastPaymentDate"
										[forceErrorState]="
											forceErrorState && !_mortgage?.lastPaymentDate
										"
										[required]="true"
										[ngModel]="_mortgage?.lastPaymentDate"
										(ngModelChange)="setLastPaymentDate($event)"
									></app-date-picker>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.lastPaymentDate
									}}</span>
								</td>
							</tr>
							<tr>
								<td>Balance Due Date</td>
								<td>
									<app-date-picker
										name="maturityDateAsReg"
										[ngModel]="_mortgage?.maturityDateAsReg"
										[placeholder]="_mortgage?.maturityDate"
										[allowString]="true"
										(ngModelChange)="setMaturityDateAsReg($event)"
									></app-date-picker>
								</td>

								<td>
									<app-date-picker
										*ngIf="registeredEditable"
										name="maturityDate"
										[forceErrorState]="
											forceErrorState && !_mortgage?.maturityDate
										"
										[required]="true"
										[ngModel]="_mortgage?.maturityDate"
										(ngModelChange)="setMaturityDate($event)"
									></app-date-picker>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.maturityDate
									}}</span>
								</td>
							</tr>
							<tr>
								<td>Interest Rate Type</td>
								<td>
									<app-input
										name="interestRateTypeAsReg"
										[ngModel]="_mortgage.interestRateTypeAsReg"
										[placeholder]="interestRateTypePlaceHolder"
										(debounce)="setInterestRateTypeAsReg($event)"
									></app-input>
								</td>
								<td>
									<app-radio-group
										*ngIf="registeredEditable"
										name="interestRateType"
										[forceErrorState]="
											forceErrorState && !_mortgage?.interestRateType
										"
										[required]="true"
										type="compact"
										[items]="interestRateTypeOptions"
										[ngModel]="_mortgage.interestRateType"
										(ngModelChange)="setInterestRateType($event)"
									></app-radio-group>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.interestRateType
									}}</span>
								</td>
							</tr>
							<tr>
								<td>Interest Rate</td>
								<td>
									<app-input
										name="interestRateAsReg"
										[ngModel]="_mortgage.interestRateAsReg"
										(debounce)="setInterestRateAsReg($event)"
										[placeholder]="interestRateAsRegPlaceholder"
									></app-input>
								</td>
								<td>
									<div
										class="flex gap-2 items-center"
										*ngIf="registeredEditable"
									>
										<ng-container
											*ngIf="_mortgage.interestRateType === variableRateType"
										>
											<app-input
												type="number"
												*ngIf="
													_mortgage.transactionType === transactionTypes.VTB
												"
												[forceErrorState]="
													forceErrorState && !_mortgage?.primeInterestRate
												"
												placeholder="Prime rate"
												[required]="true"
												name="primeInterestRate"
												[ngModel]="_mortgage.primeInterestRate"
												(debounce)="setPrimeInterestRate($event)"
												[endIcon]="ICON.PERCENTAGE"
											></app-input>
											<div
												class="text-grey"
												*ngIf="
													_mortgage.transactionType !== transactionTypes.VTB
												"
											>
												Prime
											</div>
											<app-radio-group
												type="compact"
												name="interestAbovePrime"
												[forceErrorState]="
													forceErrorState && !_mortgage?.interestAbovePrime
												"
												[required]="true"
												[items]="interestRatePrimeOptions"
												[ngModel]="_mortgage.interestAbovePrime"
												(ngModelChange)="setAbovePrime($event)"
											></app-radio-group>
										</ng-container>

										<app-input
											type="number"
											[forceErrorState]="
												forceErrorState && !_mortgage?.interestRate
											"
											placeholder="{{
												_mortgage.interestRateType === variableRateType
													? 'Adjustment factor'
													: 'Interest Rate'
											}}"
											[required]="true"
											name="interestRate"
											[ngModel]="_mortgage.interestRate"
											(debounce)="setInterestRate($event)"
											[endIcon]="ICON.PERCENTAGE"
										></app-input>
									</div>
									<div *ngIf="!registeredEditable">
										<span>{{ interestRateText }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<td>Calculation Period</td>
								<td>
									<app-dropdown
										[itemGroups]="[
											{
												items:
													_mortgage?.transactionType === transactionTypes.VTB
														? interestCalculatedOptionsVTB
														: interestCalculatedOptions,
											},
										]"
										[readonly]="false"
										[placeholder]="_mortgage.interestCalculated ?? ''"
										name="interestCalculatedAsReg"
										[ngModel]="_mortgage.interestCalculatedAsReg"
										(debounce)="setInterestCalculatedAsReg($event)"
										(onSelect)="selectInterestCalculatedAsReg($event)"
									></app-dropdown>
								</td>
								<td>
									<app-dropdown
										*ngIf="registeredEditable"
										[forceErrorState]="
											forceErrorState && !_mortgage?.interestCalculated
										"
										[required]="true"
										[itemGroups]="[
											{
												items:
													_mortgage?.transactionType === transactionTypes.VTB
														? interestCalculatedOptionsVTB
														: interestCalculatedOptions,
											},
										]"
										[readonly]="false"
										name="interestCalculated"
										[ngModel]="_mortgage.interestCalculated"
										(debounce)="setInterestCalculated($event)"
										(onSelect)="selectInterestCalculated($event)"
									></app-dropdown>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.interestCalculated
									}}</span>
								</td>
							</tr>
							<tr>
								<td>Payment Frequency</td>
								<!-- paymentFrequencyOptions -->
								<td>
									<app-dropdown
										[itemGroups]="[{ items: paymentFrequencyOptions }]"
										[readonly]="false"
										[placeholder]="_mortgage?.paymentFrequency ?? ''"
										name="paymentFrequencyAsReg"
										[ngModel]="_mortgage.paymentFrequencyAsReg"
										(debounce)="setPaymentFrequencyAsReg($event)"
										(onSelect)="selectPaymentFrequencyAsReg($event)"
									></app-dropdown>
								</td>
								<td>
									<app-dropdown
										*ngIf="registeredEditable"
										[forceErrorState]="
											forceErrorState && !_mortgage?.paymentFrequency
										"
										[required]="true"
										[itemGroups]="[{ items: paymentFrequencyOptions }]"
										[readonly]="false"
										name="paymentFrequency"
										[ngModel]="_mortgage.paymentFrequency"
										(debounce)="setPaymentFrequency($event)"
										(onSelect)="selectPaymentFrequency($event)"
									></app-dropdown>
									<!-- <app-input *ngIf="registeredEditable" [ngModel]="_mortgage?.paymentFrequency" (debounce)="setPaymentFrequency($event)"></app-input> -->
									<span *ngIf="!registeredEditable">{{
										_mortgage?.paymentFrequency
									}}</span>
								</td>
							</tr>
							<tr>
								<td></td>
								<td></td>
								<td>
									<app-checkbox
										type="clear"
										name="lenderCollectsPropertyTaxes"
										[ngModel]="_mortgage?.lenderCollectsPropertyTaxes"
										(ngModelChange)="setTaxesPaidViaMortgage($event)"
										>Property taxes and/or default insurance paid through
										mortgage</app-checkbox
									>
								</td>
							</tr>
							<tr *ngIf="_mortgage?.lenderCollectsPropertyTaxes" [@openClose]>
								<td>Principal and Interest</td>
								<td></td>
								<td>
									<app-input
										*ngIf="registeredEditable"
										[startIcon]="ICON.DOLLAR"
										type="cents"
										name="principalAndInterest"
										[ngModel]="_mortgage?.principalAndInterest"
										(debounce)="setPrincipalAndInterest($event)"
									></app-input>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.principalAndInterest
									}}</span>
								</td>
							</tr>
							<tr *ngIf="_mortgage?.lenderCollectsPropertyTaxes" [@openClose]>
								<td>Property Taxes</td>
								<td></td>
								<td>
									<app-input
										*ngIf="registeredEditable"
										name="taxes"
										[startIcon]="ICON.DOLLAR"
										type="cents"
										[ngModel]="_mortgage?.taxes"
										(debounce)="setTaxes($event)"
									></app-input>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.taxes
									}}</span>
								</td>
							</tr>
							<tr *ngIf="_mortgage?.lenderCollectsPropertyTaxes" [@openClose]>
								<td>Default Insurance</td>
								<td></td>
								<td>
									<app-input
										*ngIf="registeredEditable"
										name="other"
										[startIcon]="ICON.DOLLAR"
										type="cents"
										[ngModel]="_mortgage?.other"
										(debounce)="setOther($event)"
									></app-input>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.other
									}}</span>
								</td>
							</tr>
							<tr>
								<td>Regular Payments</td>
								<td>
									<app-input
										[ngModel]="_mortgage?.regularPaymentsAsReg"
										name="regularPaymentsAsReg"
										[placeholder]="
											(_mortgage?.regularPayments | centsToDollars) ?? ''
										"
										(debounce)="setRegularPaymentsAsReg($event)"
									></app-input>
								</td>
								<td>
									<app-input
										type="cents"
										[startIcon]="ICON.DOLLAR"
										*ngIf="registeredEditable"
										[ngModel]="_mortgage?.regularPayments"
										name="regularPayments"
										(debounce)="setRegularPayments($event)"
									></app-input>
									<span *ngIf="!registeredEditable">{{
										_mortgage?.regularPayments
									}}</span>
								</td>
							</tr>
							<ng-container
								*ngIf="
									_mortgage?.transactionType === transactionTypes.VTB &&
									_mortgage?.interestOnlyPayments !== true &&
									(fileType$ | async) === fileTypes.SALE
								"
							>
								<tr>
									<td class="align-start">Amortization Schedule</td>
									<td></td>
									<td class="flex justify-end">
										<app-button
											btn="link"
											type="submit"
											intercomAttr="amortizaiton-schedule-view-document"
											>View Document</app-button
										>
									</td>
								</tr>
								<tr
									*ngIf="
										form.submitted &&
										(!_mortgage?.term || !_mortgage?.amount || !form.valid)
									"
								>
									<td class="pt-0"></td>
									<td class="pt-0" colspan="2">
										<p class="p-sm text-end">
											<app-icon [icon]="ICON.WARNING"></app-icon>
											Unable to generate Amortization Schedule, please verify
											the fields above.
										</p>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</form>
				<app-text-area
					label="Additional Provisions"
					[ngModel]="_mortgage?.additionClauses"
					class="h-32"
					(debounce)="setAdditionalClauses($event)"
				></app-text-area>
			</div>
		</ui-section>
	</div>
</div>
